// extracted by mini-css-extract-plugin
export default {"wrapperSpinner":"Spinner_wrapperSpinner__ryrRu"};